module.exports = __webpack_public_path__ + "img/team-icon.3254493d.svg";